import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, map, take } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export const authGuard: CanActivateFn = () => {
  if (!environment.useMsal) return true;

  const msalService = inject(MsalService);
  const broadcastService = inject(MsalBroadcastService);
  const router = inject(Router);

  return broadcastService.inProgress$.pipe(
    filter((status: InteractionStatus) => status === InteractionStatus.None),
    take(1),
    map(() => {
      const accounts = msalService.instance.getAllAccounts();
      if (accounts.length > 0) {
        // Set active account if not yet set
        if (!msalService.instance.getActiveAccount()) {
          msalService.instance.setActiveAccount(accounts[0]);
        }
        return true;
      }
      return router.createUrlTree(['/login']);
    }),
  );
};

export const loginGuard: CanActivateFn = () => {
  if (!environment.useMsal) return true;

  const msalService = inject(MsalService);
  const broadcastService = inject(MsalBroadcastService);
  const router = inject(Router);

  return broadcastService.inProgress$.pipe(
    filter((status: InteractionStatus) => status === InteractionStatus.None),
    take(1),
    map(() => {
      const accounts = msalService.instance.getAllAccounts();
      if (accounts.length > 0) {
        // Already signed in → skip login, go to home
        return router.createUrlTree(['/']);
      }
      return true; // Not signed in → show login page
    }),
  );
};
